/**
 * Asynchronously loads the component for Logout
 */

import { lazyLoad } from 'utils/loadable';

export const Logout = lazyLoad(
  () => import('./index'),
  module => module.Logout,
);
